import { Suspense } from 'react';
import { useLoaderData } from "react-router-dom";
import SiteNav from './components/SiteNav.js';
import Privacy from './components/privacyPage.js';
import TrackingGameList from './components/TrackingGameList.js';
import { getHelperComponent } from './utils/helperComponents.js';
import Loading from './components/Loading.js';
import TermsAndConditions from './components/termsConditions.js';
import WhatsNew from './components/whatsNew.js';
import ContactForm from './components/contactForm.js';
import ManageAccount from './components/ManageAccount.js';
import ChangePassword from './components/changePassword.js';

export async function loader({ params }) {
    return { gameId: params.gameId, campaignId: params.id };
}

export const TrackingGameListPage = () => {
    return (
        <>
            <SiteNav />
            <TrackingGameList />
        </>
        )
}

export const PrivacyPage = () => {
    return (
        <>
            <SiteNav />
            <Privacy />
        </>
        )
}

export const TermsAndConditionsPage = () => {
    return (
        <>
            <SiteNav />
            <TermsAndConditions />
        </>
        )
}

export const WhatsNewPage = () => {
    return (
        <>
            <SiteNav />
            <WhatsNew />
        </>
        )
}

export const ContactPage = () => {
    return (
        <>
            <SiteNav />
            <ContactForm />
        </>
        )
}


export const ManageAccountPage = () => {
    return (
        <>
            <SiteNav />
            <ManageAccount />
        </>
    );
}


export const ChangePasswordPage = () => {
    return (
        <>
            <SiteNav />
            <ChangePassword />
        </>
    )
}

export const HelperPage = () => {
    const gameId = useLoaderData().gameId;
    const GameComponent = getHelperComponent(gameId);
    return (
        <div className="m-0 p-0" >
            {GameComponent ? (
                <Suspense fallback={<Loading />}>
                    <GameComponent />
                </Suspense>
            ) : (
                <div>Game ID not found</div>
            )}
        </div>
    );
}
